<template>
  <div></div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
};
</script>
